import React, { useState } from "react";

import PanelTemplate from "../../templates/Panel";
import Input from "../../components/Input";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import Box from "../../components/Box";
import PageFooter from "../../components/PageFooter";
import Button from "../../components/Button";
import { renderError } from "../../helpers/errors";
import InputEditor from "../../components/InputEditor";
import InputTextarea from "../../components/InputTextarea";
import { toast } from "react-toastify";

export const PageCreate = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const [title, setTitle] = useState('');
    const [text, setText] = useState('');
    const [slug, setSlug] = useState('');
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');

    const storePage = () => {
        setLoading(true);

        api.post(`/page`, {
            title,
            text,
            slug,
            meta_title: metaTitle,
            meta_description: metaDescription
        }).then(res => {
            toast.success('Página criada com sucesso');
            navigate(`/page/edit/${res.data.resource.id}`);
        }).catch(error => {
            renderError(error);
            setLoading(false);
        });
    }

    return (
        <>
            <PanelTemplate id="page-create">
                <Box>
                    <Input label={`Título`} value={title} change={setTitle} />
                    <Input label={`Slug`} value={slug} change={setSlug} mask={`convertToSlug`} />
                    <Input label={`Meta title`} value={metaTitle} change={setMetaTitle} />
                    <InputTextarea label={`Meta description`} value={metaDescription} change={setMetaDescription} rows={4} />
                    <h2 className="section-title">Conteúdo da página</h2>
                    <InputEditor value={text} change={setText} />
                </Box>
                <PageFooter>
                    <Button
                        type={`primary`}
                        size={`small`}
                        svg={`save-white`}
                        text={`Criar página`}
                        action={storePage}
                        loading={loading}
                    />
                </PageFooter>
            </PanelTemplate>
        </>
    );
}

export default PageCreate;
